<template>
  <!-- <div id="main-wrapper pt-0" class="show"> -->
  <div class="landing_page">
    <div class="homepage">
      <div class="container">
        <el-card class="box-card" style="margin-top: 20px; padding-top: 20px">
          <el-header style="text-align: center">
            <h1>Personal information authentication</h1>
          </el-header>
          <div class="row">
            <div class="col-xl-12 col-lg-12" style="margin-top: 40px">
              <section>
                <el-steps
                  :active="activeStep"
                  align-center
                  finish-status="success"
                >
                  <el-step title="Personal information"></el-step>
                  <el-step title="Authentication"></el-step>
                  <el-step title="Bank information"></el-step>
                  <el-step title="Additional information"></el-step>
                </el-steps>
              </section>
            </div>
          </div>
          <div class="row">
            <div
              class="col-xl-8 col-lg-8"
              style="margin-left: 10%; margin-top: 40px"
            >
              <el-form
                ref="elForm"
                :model="formData"
                :rules="rules"
                size="medium"
                label-width="100px"
                label-position="top"
              >
                <el-row>
                  <!-- <el-col :span="20">
                    <el-row>
                      <el-col :span="20">
                        <el-form-item prop="email">
                          <span slot="label"
                            >郵箱
                            <br />此郵箱為您今後的OTC賬戶，將用於接收所有重要郵件，非常重要。請確保您擁有該郵箱</span
                          >
                          <el-input
                            v-model="formData.email"
                            placeholder="請輸入郵箱"
                            clearable
                            :style="{ width: '60%' }"
                          >
                          </el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-col> -->
                  <el-col :span="16">
                    <el-row>
                      <el-col :span="12">
                        <el-row>
                          <el-col :span="21">
                            <el-form-item label="First name" prop="name">
                              <el-input
                                v-model="formData.name"
                                placeholder="Please enter your first name"
                                clearable
                                :style="{ width: '100%' }"
                              >
                              </el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-col>
                      <el-col :span="12">
                        <el-row>
                          <el-col :span="20">
                            <el-form-item label="Last name" prop="lastname">
                              <el-input
                                v-model="formData.lastname"
                                placeholder="Please enter your last name"
                                clearable
                                :style="{ width: '100%' }"
                              ></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col :span="16">
                    <el-row>
                      <el-col :span="12">
                        <el-row>
                          <el-col :span="22">
                            <el-form-item label="Country" prop="country">
                              <el-select
                                filterable
                                v-model="formData.country"
                                placeholder="Please select a country"
                                clearable
                                :style="{ width: '100%' }"
                              >
                                <el-option
                                  v-for="(item, index) in countryOptions()"
                                  :key="index"
                                  :label="item.label"
                                  :value="item.value"
                                  :disabled="item.disabled"
                                ></el-option>
                              </el-select>
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-col>
                      <el-col :span="12">
                        <el-row>
                          <el-col :span="22">
                            <el-form-item label="Address" prop="address">
                              <el-input
                                v-model="formData.address"
                                placeholder="Please enter the address"
                                clearable
                                :style="{ width: '100%' }"
                              ></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col :span="8">
                    <el-row>
                      <el-col :span="22">
                        <el-form-item label="City" prop="city">
                          <el-input
                            v-model="formData.city"
                            placeholder="Please enter the city"
                            clearable
                            :style="{ width: '100%' }"
                          >
                          </el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col :span="8">
                    <el-row>
                      <el-col :span="22">
                        <el-form-item label="Province" prop="province">
                          <el-input
                            v-model="formData.province"
                            placeholder="Please enter the state.or province"
                            clearable
                            :style="{ width: '100%' }"
                          >
                          </el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col :span="8">
                    <el-row>
                      <el-col :span="22">
                        <el-form-item label="Postcode" prop="postcode">
                          <el-input
                            v-model="formData.postcode"
                            placeholder="Please enter the zip code"
                            clearable
                            :style="{ width: '100%' }"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col :span="16">
                    <el-row>
                      <el-col :span="12">
                        <el-row>
                          <el-col :span="22">
                            <el-form-item label="Birthday" prop="birthday">
                              <el-date-picker
                                v-model="formData.birthday"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                :style="{ width: '100%' }"
                                placeholder="Please choose a birthday"
                                clearable
                              ></el-date-picker>
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-col>
                      <el-col :span="12">
                        <el-row>
                          <el-col :span="22">
                            <el-form-item label="Telephone number" prop="phone">
                              <el-input
                                v-model="formData.phone"
                                placeholder="Please enter your phone number"
                                clearable
                                :style="{ width: '100%' }"
                              ></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                  </el-col>
                </el-row>

                <el-row :gutter="20" style="margin-top: 40px">
                  <el-col :span="6" :offset="0"></el-col>
                  <el-col :span="10" :offset="10">
                    <el-form-item size="large">
                      <el-button type="primary" @click="submitForm"
                        >Submit</el-button
                      >
                      <el-button @click="resetForm">Reset</el-button>
                    </el-form-item></el-col
                  >
                </el-row>
              </el-form>
            </div>
          </div>
        </el-card>
      </div>
    </div>
    <!-- <Footer /> -->
  </div>
</template>
<script>
import {
  otc_auth_status,
  get_persional_info,
  att_persional_info,
} from "../../plugins/api/account_otc";
import { countryOptions } from "../../plugins/data/form_base_data";
// import Footer from "../../components/Footer.vue";
export default {
  components: {}, // Footer
  props: [],
  data() {
    return {
      activeStep: 0,
      formData: {
        name: "",
        lastname: "",
        country: "",
        address: "",
        city: "",
        province: "",
        postcode: "",
        birthday: null,
        phone: "",
      },
      rules: {
        // email: [
        //   {
        //     required: true,
        //     message: "請輸入郵箱",
        //     trigger: "blur",
        //   },
        // ],
        name: [
          {
            required: true,
            message: "Please enter your first name",
            trigger: "blur",
          },
        ],
        lastname: [
          {
            required: true,
            message: "Please enter your last name",
            trigger: "blur",
          },
        ],
        country: [
          {
            required: true,
            message: "Please select a country",
            trigger: "change",
          },
        ],
        address: [
          {
            required: true,
            message: "Please enter the address",
            trigger: "blur",
          },
        ],
        city: [
          {
            required: true,
            message: "Please enter the city",
            trigger: "blur",
          },
        ],
        province: [
          {
            required: true,
            message: "Please enter the state.or province",
            trigger: "blur",
          },
        ],
        postcode: [
          {
            required: true,
            message: "Please enter the zip code",
            trigger: "blur",
          },
        ],
        birthday: [
          {
            required: true,
            message: "Please choose a birthday",
            trigger: "change",
          },
        ],
        phone: [
          {
            required: true,
            message: "Please enter your phone number",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {},
  watch: {},
  created() {
    otc_auth_status().then((res) => {
      if (res && res.data) {
        // console.log("reg attach info complete!");
      }
    });

    get_persional_info().then((res_query) => {
      if (res_query.data && res_query.data.name) {
        this.$Message.success("This information has been stored");
        this.formData = res_query.data;
      } else {
        this.$alert(
          "Before you start trading, you need to refine your personal Authentication Information",
          "prompt",
          {
            confirmButtonText: "Enter",
            callback: (action) => {},
          }
        );
      }
    });
  },
  mounted() {},
  methods: {
    countryOptions() {
      return countryOptions;
    },
    submitForm() {
      this.$refs["elForm"].validate((valid) => {
        if (!valid) return;
        att_persional_info(this.formData).then((res) => {
          console.log(res);
          if (res.code == 0 || res.code == 18289475) {
            this.$router.push("/reg/person/step2");
          } else {
          }
        });
        // TODO 提交表單
      });
    },
    resetForm() {
      this.$refs["elForm"].resetFields();
    },
  },
};
</script>
<style>
</style>
